import { useEffect, useState } from "react";
import { api } from "./api";

let cached = {
  categories: [],
  stages: [],
  courses: [],
};
let initialized = false;
const listeners = new Set();

export function snapshot() {
  return {
    categories: cached.categories,
    stages: cached.stages,
    courses: cached.courses,
    CATEGORIES: cached.categories.map((c) => c.name),
    STAGES: cached.stages.map((s) => s.name),
    COURSES: cached.courses.map((c) => c.name),
    CATEGORY_COLORS: Object.fromEntries(cached.categories.map((c) => [c.name, c.color || "#6C47FF"])),
    STAGE_COLORS: Object.fromEntries(cached.stages.map((s) => [s.name, s.color || "#6C47FF"])),
  };
}

export async function refreshLookups() {
  try {
    const { data } = await api.get("/lookups");
    cached = {
      categories: data.categories || [],
      stages: data.stages || [],
      courses: data.courses || [],
    };
    initialized = true;
    const snap = snapshot();
    listeners.forEach((cb) => cb(snap));
    return snap;
  } catch (e) {
    return snapshot();
  }
}

export function useLookups() {
  const [val, setVal] = useState(snapshot());
  useEffect(() => {
    const cb = (v) => setVal(v);
    listeners.add(cb);
    if (!initialized) refreshLookups();
    return () => listeners.delete(cb);
  }, []);
  return val;
}
